import React, { useState } from "react";
import "./DuplicatesTabComponentStyle.css";
const DuplicateTabTableSecondaryBrandValue: React.FC<{ brands: any[] }> = ({
  brands,
}) => {
  const [showMore, setShowMore] = useState(false);
  if (!brands || brands.length === 0) {
    return <span className="noDuplicates">No duplicates</span>;
  }
  const showList = showMore ? brands : brands.slice(0, 5);
  return (
    <div>
      <ul className="secondaryBrandList">
        {showList.map((brand: any) => (
          <li key={brand.key} className="secondaryBrandItem">
            {brand.value}
          </li>
        ))}
      </ul>
      {brands.length > 5 && (
        <div
          className="showMore"
          onClick={(e) => {
            // e.stopPropagation();
            setShowMore(!showMore);
          }}
        >
          <div>{showMore ? "Show less" : `Show more...`}</div>
        </div>
      )}
    </div>
  );
};

export default DuplicateTabTableSecondaryBrandValue;
